import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.traffic.main');
import { OnInit, OnDestroy, ElementRef, ViewChild } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

declare var vw: any;
declare var ol: any;

// ─── 10 Model Nodes (backend prediction) ───
const JISO_LIST = [
    "대남교차로", "대연사거리", "민락교차로", "삼호가든앞교차로",
    "센텀고교교차로", "센텀시티교차로", "센텀중앙로2", "수영교차로",
    "올림픽동산", "해운대경찰서앞교차로"
];

// ─── All 10 Intersections (accurate coords) ───
const ALL_COORDS: any = {
    "대남교차로": [35.139892, 129.105364],
    "대연사거리": [35.135177, 129.091921],
    "민락교차로": [35.165634, 129.125203],
    "삼호가든앞교차로": [35.171028, 129.135528],
    "센텀고교교차로": [35.177976, 129.126973],
    "센텀시티교차로": [35.167228, 129.129091],
    "센텀중앙로2": [35.176650, 129.124509],
    "수영교차로": [35.167364, 129.115203],
    "올림픽동산": [35.164863, 129.131329],
    "해운대경찰서앞교차로": [35.184628, 129.121031],
};

const CONNECTIONS: any = {
    "대남교차로": ["대연사거리", "수영교차로"],
    "대연사거리": ["대남교차로", "수영교차로"],
    "민락교차로": ["수영교차로", "삼호가든앞교차로"],
    "삼호가든앞교차로": ["민락교차로", "센텀시티교차로", "올림픽동산", "해운대경찰서앞교차로"],
    "센텀고교교차로": ["센텀중앙로2", "수영교차로"],
    "센텀시티교차로": ["삼호가든앞교차로", "수영교차로", "센텀중앙로2"],
    "센텀중앙로2": ["센텀시티교차로", "센텀고교교차로"],
    "수영교차로": ["대남교차로", "대연사거리", "민락교차로", "센텀시티교차로", "센텀고교교차로"],
    "올림픽동산": ["삼호가든앞교차로", "해운대경찰서앞교차로"],
    "해운대경찰서앞교차로": ["삼호가든앞교차로", "올림픽동산"],
};

const CCTV_MAPPING: any = {
    "대남교차로": ["cctv_829", "cctv_831", "cctv_832"],
    "대연사거리": ["cctv_825"],
    "삼호가든앞교차로": ["cctv_886", "cctv_889", "cctv_890"],
    "센텀고교교차로": ["cctv_964"],
    "센텀시티교차로": ["cctv_877", "cctv_880", "cctv_881"],
    "해운대경찰서앞교차로": ["cctv_956"],
};

const NODE_DIRECTIONS: any = {
    0: ['대연사거리', '49호광장'],
    1: ['문현교차로', '대남교차로'],
    2: ['수영교차로', '센텀시티'],
    3: ['올림픽교차로', '원동IC'],
    4: ['센텀시티역', '수영강변'],
    5: ['수영교', '올림픽교차로'],
    6: ['수영강변', '센텀시티역'],
    7: ['망미역', '광안역'],
    8: ['센텀시티', '해운대신시가지'],
    9: ['원동IC', '해운대신시가지'],
};

@Component({
    selector: 'wiz-page-traffic-main',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.traffic.main/view.scss */
@charset "UTF-8";
:host {
  display: block;
  height: 100%;
}

.traffic-main-wrapper {
  position: relative;
  width: 100%;
  height: 100%;
  overflow: hidden;
  font-family: "Pretendard", "Noto Sans KR", sans-serif;
  color: #e8eaed;
}

/* ─── Sidebar Toggle ─── */
.sidebar-toggle-btn {
  position: absolute;
  top: 12px;
  left: 12px;
  z-index: 1100;
  width: 40px;
  height: 40px;
  background: rgba(26, 29, 35, 0.92);
  border: 1px solid #2d3139;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: #e8eaed;
  font-size: 16px;
  backdrop-filter: blur(8px);
  transition: background 0.2s;
}
.sidebar-toggle-btn:hover {
  background: rgba(35, 39, 46, 0.95);
}

/* ─── Sidebar ─── */
.sidebar-panel {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  width: 360px;
  background: #1a1d23;
  border-right: 1px solid #2d3139;
  transform: translateX(-100%);
  transition: transform 0.3s ease;
  z-index: 1200;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}
.sidebar-panel.open {
  transform: translateX(0);
}

.sidebar-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 18px;
  border-bottom: 1px solid #2d3139;
  background: #16181d;
}

.sidebar-title {
  font-size: 16px;
  font-weight: 700;
  color: #4fc3f7;
  display: flex;
  align-items: center;
}

.sidebar-close {
  background: none;
  border: none;
  color: #9aa0a6;
  font-size: 18px;
  cursor: pointer;
  padding: 4px;
}
.sidebar-close:hover {
  color: #e8eaed;
}

.sidebar-section {
  padding: 14px 18px;
  border-bottom: 1px solid #2d3139;
}

.sidebar-clock {
  font-size: 13px;
  color: #9aa0a6;
  font-variant-numeric: tabular-nums;
}

.sidebar-status {
  display: flex;
  align-items: center;
  gap: 6px;
  margin-top: 6px;
  font-size: 12px;
  color: #9aa0a6;
}

.status-dot {
  width: 7px;
  height: 7px;
  border-radius: 50%;
}
.status-dot.status-live {
  background: #00b894;
  animation: blink 1.5s infinite;
}
.status-dot.status-pred {
  background: #74b9ff;
}

@keyframes blink {
  0%, 100% {
    opacity: 1;
  }
  50% {
    opacity: 0.3;
  }
}
.sidebar-section-title {
  font-size: 12px;
  font-weight: 600;
  color: #9aa0a6;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin-bottom: 10px;
}

/* Data Info Box */
.data-info-box {
  display: flex;
  align-items: center;
  gap: 4px;
  font-size: 12px;
  color: #4fc3f7;
  background: rgba(79, 195, 247, 0.08);
  padding: 8px 12px;
  border-radius: 8px;
  border: 1px solid rgba(79, 195, 247, 0.2);
}

/* Summary */
.summary-badges {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 8px;
}

.summary-badge {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 10px 4px;
  border-radius: 8px;
  background: #23272e;
}
.summary-badge .badge-count {
  font-size: 22px;
  font-weight: 700;
}
.summary-badge .badge-label {
  font-size: 10px;
  color: #9aa0a6;
  margin-top: 2px;
}
.summary-badge .badge-range {
  font-size: 9px;
  color: #9aa0a6;
  margin-top: 1px;
  opacity: 0.7;
}
.summary-badge.smooth .badge-count {
  color: #00b894;
}
.summary-badge.congestion .badge-count {
  color: #f39c12;
}
.summary-badge.jam .badge-count {
  color: #d63031;
}
.summary-badge.none .badge-count {
  color: #636e72;
}

/* Layers */
.layer-toggles {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.layer-toggle {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 13px;
  color: #e8eaed;
  cursor: pointer;
}
.layer-toggle input[type=checkbox] {
  accent-color: #4fc3f7;
  width: 16px;
  height: 16px;
  cursor: pointer;
}

/* Node List */
.node-list-section {
  flex: 1;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.node-list {
  flex: 1;
  overflow-y: auto;
  margin: 0 -18px;
  padding: 0 18px;
}
.node-list::-webkit-scrollbar {
  width: 4px;
}
.node-list::-webkit-scrollbar-thumb {
  background: #2d3139;
  border-radius: 2px;
}

.node-item {
  padding: 10px 12px;
  border-radius: 8px;
  margin-bottom: 4px;
  cursor: pointer;
  transition: background 0.15s;
}
.node-item:hover {
  background: rgba(79, 195, 247, 0.08);
}
.node-item.active {
  background: rgba(79, 195, 247, 0.15);
  border-left: 3px solid #4fc3f7;
}

.node-item-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.node-item-name {
  font-size: 13px;
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: 4px;
}
.node-item-name .node-idx {
  color: #4fc3f7;
  margin-right: 6px;
  font-size: 11px;
}

.node-item-badges {
  display: flex;
  gap: 4px;
}

.node-badge {
  font-size: 10px;
  color: #fff;
  padding: 2px 7px;
  border-radius: 4px;
  font-weight: 600;
}

.node-item-detail {
  display: flex;
  gap: 16px;
  margin-top: 6px;
}

.node-item-pred {
  display: flex;
  gap: 16px;
  margin-top: 3px;
  padding-top: 3px;
  border-top: 1px dashed rgba(116, 185, 255, 0.3);
}

.speed-pair {
  display: flex;
  gap: 4px;
  font-size: 11px;
}

.dir-label {
  color: #9aa0a6;
}

.dir-speed {
  color: #e8eaed;
  font-weight: 500;
  font-variant-numeric: tabular-nums;
}

.dir-speed.pred {
  color: #74b9ff;
  font-weight: 400;
}

.sidebar-footer {
  padding: 12px 18px;
  border-top: 1px solid #2d3139;
}

.logout-btn {
  width: 100%;
  padding: 8px;
  border: 1px solid #2d3139;
  border-radius: 8px;
  background: transparent;
  color: #9aa0a6;
  font-size: 13px;
  cursor: pointer;
  transition: all 0.15s;
}
.logout-btn:hover {
  color: #d63031;
  border-color: #d63031;
}

/* ─── Map ─── */
.map-area {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  transition: left 0.3s ease;
}
.map-area.sidebar-open {
  left: 360px;
}

.map-container {
  width: 100%;
  height: 100%;
}

.map-loading {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 500;
  display: flex;
  flex-direction: column;
  align-items: center;
  color: #9aa0a6;
  font-size: 14px;
}

/* ─── Breathing Node ─── */
.breathing-node {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  cursor: pointer;
  z-index: 100;
  transition: transform 0.15s;
}
.breathing-node:hover {
  transform: scale(1.12);
  z-index: 150;
}
.breathing-node.active {
  transform: scale(1.18);
  z-index: 200;
}

.breathing-ring {
  position: absolute;
  top: 50%;
  left: 50%;
  width: 44px;
  height: 44px;
  margin-top: -22px;
  margin-left: -22px;
  border-radius: 50%;
  border: 2px solid rgba(99, 110, 114, 0.4);
  pointer-events: none;
  animation: breathing-expand 2.5s ease-out infinite;
}

.breathing-ring-delay {
  animation-delay: 1.25s;
}

/* Status-specific ring colors */
.breathing-node.status-소통 .breathing-ring {
  border-color: rgba(0, 184, 148, 0.5);
  animation-duration: 2.5s;
}

.breathing-node.status-혼잡 .breathing-ring {
  border-color: rgba(243, 156, 18, 0.55);
  animation-duration: 2s;
}

.breathing-node.status-정체 .breathing-ring {
  border-color: rgba(214, 48, 49, 0.6);
  animation-duration: 1.6s;
}

.breathing-node.status-미수신 .breathing-ring {
  border-color: rgba(99, 110, 114, 0.3);
  animation-duration: 3s;
}

@keyframes breathing-expand {
  0% {
    transform: scale(0.8);
    opacity: 1;
  }
  100% {
    transform: scale(2.2);
    opacity: 0;
  }
}
.breathing-circle {
  position: relative;
  width: 42px;
  height: 42px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.45);
  border: 2px solid rgba(255, 255, 255, 0.18);
  z-index: 2;
}

.breathing-speed {
  font-size: 13px;
  font-weight: 700;
  color: #fff;
  text-shadow: 0 1px 3px rgba(0, 0, 0, 0.6);
}

.breathing-label {
  margin-top: 4px;
  font-size: 10px;
  font-weight: 600;
  color: #fff;
  text-shadow: 0 1px 4px rgba(0, 0, 0, 0.8);
  white-space: nowrap;
  text-align: center;
}

/* ─── CCTV Map Icons ─── */
.cctv-map-icon {
  display: flex;
  flex-direction: column;
  align-items: center;
  cursor: pointer;
  z-index: 90;
}
.cctv-map-icon.has-stream .cctv-icon-inner {
  background: #00b894;
}
.cctv-map-icon.no-stream .cctv-icon-inner {
  background: #636e72;
}

.cctv-icon-inner {
  width: 28px;
  height: 28px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  color: #fff;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.3);
  border: 2px solid rgba(255, 255, 255, 0.2);
  transition: transform 0.15s;
}
.cctv-icon-inner:hover {
  transform: scale(1.2);
}

.cctv-icon-label {
  font-size: 9px;
  color: #e8eaed;
  margin-top: 2px;
  text-shadow: 0 1px 3px rgba(0, 0, 0, 0.7);
  white-space: nowrap;
}

/* ─── CCTV Panel (draggable, resizable) ─── */
.cctv-panel {
  position: fixed;
  background: #1a1d23;
  border: 1px solid #2d3139;
  border-radius: 12px;
  z-index: 2000;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.5);
}

.cctv-panel-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 14px;
  border-bottom: 1px solid #2d3139;
  background: #16181d;
  cursor: grab;
  user-select: none;
}
.cctv-panel-header:active {
  cursor: grabbing;
}

.cctv-panel-title {
  font-size: 13px;
  font-weight: 600;
  color: #e8eaed;
  display: flex;
  align-items: center;
}

.cctv-panel-close {
  background: none;
  border: none;
  color: #9aa0a6;
  font-size: 16px;
  cursor: pointer;
  padding: 2px;
}
.cctv-panel-close:hover {
  color: #e8eaed;
}

/* CCTV Tabs */
.cctv-tabs {
  display: flex;
  gap: 0;
  border-bottom: 1px solid #2d3139;
  background: #181b20;
  overflow-x: auto;
}
.cctv-tabs::-webkit-scrollbar {
  height: 2px;
}
.cctv-tabs::-webkit-scrollbar-thumb {
  background: #2d3139;
}

.cctv-tab {
  flex: 0 0 auto;
  padding: 6px 14px;
  font-size: 11px;
  color: #9aa0a6;
  background: none;
  border: none;
  border-bottom: 2px solid transparent;
  cursor: pointer;
  white-space: nowrap;
  transition: all 0.15s;
}
.cctv-tab:hover {
  color: #e8eaed;
  background: rgba(79, 195, 247, 0.06);
}
.cctv-tab.active {
  color: #4fc3f7;
  border-bottom-color: #4fc3f7;
  font-weight: 600;
}

.cctv-panel-body {
  flex: 1;
  background: #000;
}

.cctv-resize-handle {
  position: absolute;
  right: 0;
  bottom: 0;
  width: 16px;
  height: 16px;
  cursor: nwse-resize;
  background: linear-gradient(135deg, transparent 50%, rgba(255, 255, 255, 0.2) 50%);
  border-radius: 0 0 12px 0;
  z-index: 10;
}

/* ─── Popup Panel ─── */
.popup-panel {
  position: absolute;
  top: 12px;
  right: 12px;
  bottom: 12px;
  width: 340px;
  background: #1a1d23;
  border: 1px solid #2d3139;
  border-radius: 12px;
  z-index: 1300;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.4);
}
.popup-panel.sidebar-open {
  right: 12px;
}

.popup-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 14px 18px;
  border-bottom: 1px solid #2d3139;
  background: #16181d;
}

.popup-title {
  font-size: 15px;
  font-weight: 700;
  color: #e8eaed;
  display: flex;
  align-items: center;
}

.popup-close {
  background: none;
  border: none;
  color: #9aa0a6;
  font-size: 18px;
  cursor: pointer;
  padding: 4px;
}
.popup-close:hover {
  color: #e8eaed;
}

.popup-body {
  flex: 1;
  overflow-y: auto;
  padding: 14px 18px;
}
.popup-body::-webkit-scrollbar {
  width: 4px;
}
.popup-body::-webkit-scrollbar-thumb {
  background: #2d3139;
  border-radius: 2px;
}

.popup-section {
  margin-bottom: 18px;
}

.popup-section-title {
  font-size: 12px;
  font-weight: 600;
  color: #9aa0a6;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin-bottom: 10px;
  display: flex;
  align-items: center;
}

.popup-speed-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 10px;
}

.popup-speed-card {
  background: #23272e;
  border-radius: 8px;
  padding: 12px;
  text-align: center;
}
.popup-speed-card.pred {
  background: rgba(116, 185, 255, 0.07);
  border: 1px solid rgba(116, 185, 255, 0.2);
}

.popup-speed-dir {
  font-size: 11px;
  color: #9aa0a6;
  font-weight: 600;
  margin-bottom: 4px;
  line-height: 1.35;
}

.popup-speed-value {
  font-size: 28px;
  font-weight: 700;
  font-variant-numeric: tabular-nums;
  color: #e8eaed;
}

.popup-speed-unit {
  font-size: 12px;
  font-weight: 400;
  color: #9aa0a6;
  margin-left: 2px;
}

.popup-speed-label {
  display: inline-block;
  margin-top: 6px;
  font-size: 10px;
  color: #fff;
  padding: 2px 8px;
  border-radius: 4px;
  font-weight: 600;
}

.popup-chart-wrap {
  background: #23272e;
  border-radius: 8px;
  padding: 10px;
  height: 180px;
  position: relative;
}

.popup-chart-empty {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #9aa0a6;
  font-size: 12px;
  border: 1px dashed rgba(255, 255, 255, 0.12);
  border-radius: 6px;
}

/* Fallback / Info Notice (popup) */
.fallback-notice {
  background: rgba(79, 195, 247, 0.08);
  border: 1px solid rgba(79, 195, 247, 0.2);
  border-radius: 8px;
  padding: 10px 12px;
  margin-bottom: 14px;
  font-size: 12px;
  color: #4fc3f7;
  display: flex;
  align-items: flex-start;
  line-height: 1.5;
}

/* Popup CCTV List */
.popup-cctv-list {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}

.popup-cctv-btn {
  padding: 6px 12px;
  font-size: 11px;
  color: #e8eaed;
  background: #23272e;
  border: 1px solid #2d3139;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.15s;
  display: flex;
  align-items: center;
}
.popup-cctv-btn:hover {
  background: rgba(0, 184, 148, 0.15);
  border-color: #00b894;
  color: #00b894;
}

.popup-incident {
  background: #23272e;
  border-radius: 8px;
  padding: 10px 12px;
  margin-bottom: 6px;
  border-left: 3px solid #f39c12;
  transition: border-left-color 0.2s;
}

.popup-incident.incident-empty {
  border-left-color: #00b894;
  background: rgba(0, 184, 148, 0.08);
}

.incident-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  margin-bottom: 4px;
}

.incident-type {
  font-size: 12px;
  font-weight: 700;
}

.incident-time {
  font-size: 11px;
  color: #9aa0a6;
  white-space: nowrap;
}

.incident-desc {
  font-size: 11px;
  color: #9aa0a6;
  line-height: 1.5;
  word-break: keep-all;
}

/* ─── Utility ─── */
.mr-1 {
  margin-right: 4px;
}

.mr-2 {
  margin-right: 8px;
}

.ml-1 {
  margin-left: 4px;
}

.mt-2 {
  margin-top: 8px;
}

.text-yellow-500 {
  color: #f39c12;
}`],
})
export class PageTrafficMainComponent implements OnInit, OnDestroy {
    @ViewChild('mapContainer') mapContainer: ElementRef;

    public currentTime: string = '';
    public lastReceived: string = '-';
    public actualTs: string = '';
    public predTs: string = '';
    public nodes: any[] = [];
    public selectedNode: any = null;
    public selectedNodeId: number = -1;
    public chartData: any[] = [];
    public forecastData: any[] = [];
    public popupVisible: boolean = false;
    public popupData: any = null;
    public mapLoading: boolean = true;

    public layerPrediction: boolean = true;
    public layerCctv: boolean = true;
    public layerIncident: boolean = true;

    public summary = { smooth: 0, congestion: 0, jam: 0, none: 0 };

    public sidebarOpen: boolean = false;
    public cctvPanelVisible: boolean = false;
    public cctvPanelData: any = null;
    public cctvPanelCameras: any[] = [];
    public cctvPanelSelectedIdx: number = 0;
    public cctvAllData: any = {};
    public currentZoom: number = 14;
    public debugMsg: string = '';

    // CCTV panel drag/resize state
    public cctvPanelPos = { x: 310, y: 70 };
    public cctvPanelSize = { w: 420, h: 320 };
    public nodeDirections: any = { ...NODE_DIRECTIONS };
    private cctvDragging = false;
    private cctvResizing = false;
    private cctvDragStart = { mx: 0, my: 0, px: 0, py: 0 };
    private cctvResizeStart = { mx: 0, my: 0, w: 0, h: 0 };
    private boundCctvDragMove: any;
    private boundCctvDragEnd: any;
    private boundCctvResizeMove: any;
    private boundCctvResizeEnd: any;

    private map: any = null;
    private overlays: any[] = [];
    private cctvOverlays: any[] = [];
    private eventSource: any = null;
    private clockInterval: any = null;
    private hlsInstance: any = null;
    private styleInjected: boolean = false;
    private chartInstance: any = null;
    private forecastChartInstance: any = null;
    private incidentInterval: any = null;

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
        this.injectBreathingKeyframes();
        const token = sessionStorage.getItem('traffic_token');
        if (!token) { this.service.href('/access'); return; }
        try {
            const res = await this.service.request.post('/api/auth/verify', { token });
            if (res.code !== 200) { sessionStorage.removeItem('traffic_token'); this.service.href('/access'); return; }
        } catch (e) { this.service.href('/access'); return; }
        try { await this.service.request.post('/api/auth/init', {}); } catch (e) { }

        this.nodes = JISO_LIST.map((name, i) => ({
            node_id: i, jiso_name: name,
            spd_up: null, spd_dn: null,
            pred_spd_up: null, pred_spd_dn: null,
            label_up: '미수신', label_dn: '미수신',
            color_up: '#636e72', color_dn: '#636e72',
            direction_up: this.getDirectionLabel(i, 0),
            direction_dn: this.getDirectionLabel(i, 1),
            fallback_used: 0,
        }));
        this.startClock();
        await this.service.render();
        await this.loadVWorldSDK();
        await this.loadMeta();
        this.loadCurrentData().then(async () => {
            this.updateMapMarkers();
            await this.service.render();
        }).catch((err) => {
            this.debugMsg = `데이터 로드 실패: ${err?.message || err}`;
            this.service.render();
        });
        this.loadAllCctvData();
        this.connectSSE();
    }

    ngOnDestroy() {
        if (this.clockInterval) clearInterval(this.clockInterval);
        if (this.incidentInterval) clearInterval(this.incidentInterval);
        if (this.eventSource) this.eventSource.close();
        this.destroyHls();
        if (this.chartInstance) { this.chartInstance.destroy(); this.chartInstance = null; }
        if (this.forecastChartInstance) { this.forecastChartInstance.destroy(); this.forecastChartInstance = null; }
    }

    private destroyHls() {
        if (this.hlsInstance) { this.hlsInstance.destroy(); this.hlsInstance = null; }
    }

    private injectBreathingKeyframes() {
        if (this.styleInjected) return;
        this.styleInjected = true;
        const existing = document.getElementById('breathing-keyframes');
        if (existing) return;
        const style = document.createElement('style');
        style.id = 'breathing-keyframes';
        style.textContent = `
            @keyframes breathing-expand {
                0% { transform: scale(0.8); opacity: 1; }
                100% { transform: scale(2.2); opacity: 0; }
            }
        `;
        document.head.appendChild(style);
    }

    // ─── VWorld SDK ───
    private waitForVWorldReady(maxWait: number = 30000): Promise<boolean> {
        return new Promise((resolve) => {
            const start = Date.now();
            const check = () => {
                const elapsed = Date.now() - start;
                try {
                    if (typeof vw !== 'undefined' && typeof vw.MapController === 'function' &&
                        typeof ol !== 'undefined' && !!ol.proj) { resolve(true); return; }
                } catch (e) { }
                if (elapsed > maxWait) { resolve(false); return; }
                setTimeout(check, 300);
            };
            check();
        });
    }

    private loadVWorldSDK(): Promise<void> {
        return new Promise(async (resolve) => {
            try {
                if (typeof vw !== 'undefined' && typeof vw.MapController === 'function') {
                    await this.initMap(); resolve(); return;
                }
            } catch (e) { }
            const script = document.createElement('script');
            script.src = '/api/proxy/vworld/sdk';
            script.onload = async () => {
                const ready = await this.waitForVWorldReady(30000);
                if (ready) await this.initMap();
                else { this.mapLoading = false; this.debugMsg = 'VWorld SDK 로드 실패'; await this.service.render(); }
                resolve();
            };
            script.onerror = async () => { this.mapLoading = false; this.debugMsg = 'VWorld SDK 스크립트 오류'; await this.service.render(); resolve(); };
            document.head.appendChild(script);
        });
    }

    // ─── Clock ───
    startClock() {
        const update = () => {
            const now = new Date();
            this.currentTime = now.toLocaleString('ko-KR', {
                year: 'numeric', month: '2-digit', day: '2-digit',
                hour: '2-digit', minute: '2-digit', second: '2-digit', hour12: false
            });
        };
        update();
        this.clockInterval = setInterval(async () => { update(); await this.service.render(); }, 1000);
    }

    formatTs(ts: string): string {
        if (!ts) return '-';
        try {
            const d = new Date(ts);
            return `${(d.getMonth()+1).toString().padStart(2,'0')}/${d.getDate().toString().padStart(2,'0')} ${d.getHours().toString().padStart(2,'0')}:00`;
        } catch (e) { return ts; }
    }

    // ─── Data ───
    async loadMeta() {
        try {
            const res = await this.service.request.post('/api/data/meta', {});
            const directions = res?.data?.directions || res?.directions;
            if (directions) this.nodeDirections = directions;
        } catch (e) { }
    }

    getDirectionLabel(nodeId: number, dirIdx: number): string {
        const dirs = this.nodeDirections?.[nodeId] || this.nodeDirections?.[String(nodeId)] || NODE_DIRECTIONS[nodeId] || [];
        const dir = dirs[dirIdx];
        if (!dir) return '';
        const label = String(dir).trim();
        return /방향$/.test(label) ? label : `${label}방향`;
    }

    async loadCurrentData() {
        try {
            const res = await this.service.request.post('/api/data/current', {});
            if (res && res.code === 200 && res.data) {
                const respData = res.data;
                this.nodes = this.buildNodeList(respData.data || respData || []);
                this.actualTs = respData.actual_ts || '';
                this.predTs = respData.pred_ts || '';
                this.lastReceived = respData.actual_ts || '-';
                this.updateSummary();
                this.debugMsg = '';
            } else {
                const code = res?.code || res?.status || 'unknown';
                this.debugMsg = `API 응답 코드: ${code}`;
            }
        } catch (e: any) {
            this.debugMsg = `API 호출 오류: ${e?.message || e}`;
        }
    }

    buildNodeList(data: any[]) {
        if (!Array.isArray(data)) {
            if (data && typeof data === 'object') data = Object.values(data);
            else return this.nodes;
        }
        const nodeMap: any = {};
        for (const d of data) nodeMap[d.node_id] = d;
        return JISO_LIST.map((name, i) => {
            const d = nodeMap[i] || {};
            return {
                node_id: i, jiso_name: name,
                spd_up: d.spd_up ?? null, spd_dn: d.spd_dn ?? null,
                pred_spd_up: d.pred_spd_up ?? null, pred_spd_dn: d.pred_spd_dn ?? null,
                label_up: d.label_up || '미수신', label_dn: d.label_dn || '미수신',
                color_up: d.color_up || '#636e72', color_dn: d.color_dn || '#636e72',
                pred_label_up: d.pred_label_up || null, pred_label_dn: d.pred_label_dn || null,
                pred_color_up: d.pred_color_up || null, pred_color_dn: d.pred_color_dn || null,
                direction_up: this.getDirectionLabel(i, 0),
                direction_dn: this.getDirectionLabel(i, 1),
                fallback_used: d.fallback_used || 0,
            };
        });
    }

    updateSummary() {
        this.summary = { smooth: 0, congestion: 0, jam: 0, none: 0 };
        for (const n of this.nodes) {
            // 상행/하행 중 더 나쁜 쪽 기준으로 요약
            const worst = this.getWorstLabel(n.label_up, n.label_dn);
            if (worst === '소통') this.summary.smooth++;
            else if (worst === '혼잡') this.summary.congestion++;
            else if (worst === '정체') this.summary.jam++;
            else this.summary.none++;
        }
    }

    getStatusColor(label: string) {
        if (label === '소통') return '#00b894';
        if (label === '혼잡') return '#f39c12';
        if (label === '정체') return '#d63031';
        return '#636e72';
    }

    private getRingColor(label: string): string {
        if (label === '소통') return 'rgba(0, 184, 148, 0.5)';
        if (label === '혼잡') return 'rgba(243, 156, 18, 0.55)';
        if (label === '정체') return 'rgba(214, 48, 49, 0.6)';
        return 'rgba(99, 110, 114, 0.3)';
    }

    private getRingDuration(label: string): string {
        if (label === '소통') return '2.5s';
        if (label === '혼잡') return '2s';
        if (label === '정체') return '1.6s';
        return '3s';
    }

    // ─── Map Init ───
    async initMap() {
        try {
            const busanCenter = ol.proj.transform([129.118, 35.165], 'EPSG:4326', 'EPSG:3857');
            const initPosition = { center: busanCenter, zoom: 14, rotation: 0 };
            this.map = new vw.MapController({
                container: 'vmap', mapMode: '2d-map', basemapType: 'graphic',
                epsg: 'EPSG:3857', controlDensity: 'empty', interactionDensity: 'basic',
                controlsAutoArrange: true, homePosition: initPosition, initPosition: initPosition,
            });
            const olMap = this.getOlMap();
            if (olMap) {
                olMap.getView().setCenter(busanCenter);
                olMap.getView().setZoom(14);
                olMap.getView().on('change:resolution', () => {
                    const zoom = Math.round(olMap.getView().getZoom());
                    if (zoom !== this.currentZoom) {
                        this.currentZoom = zoom;
                        this.updateCctvMarkers();
                        this.service.render();
                    }
                });
            }
            this.mapLoading = false;
            this.updateMapMarkers();
            await this.service.render();
        } catch (e) { this.mapLoading = false; await this.service.render(); }
    }

    private getOlMap() {
        if (!this.map) return null;
        if (this.map.Map2D) return this.map.Map2D;
        if (typeof this.map.getMap === 'function') return this.map.getMap();
        return this.map;
    }

    // ─── Node Markers (Breathing Node) - 실측 속도 표시 ───
    updateMapMarkers() {
        const olMap = this.getOlMap();
        if (!olMap) return;
        try {
            for (const ov of this.overlays) { try { olMap.removeOverlay(ov); } catch (e) { } }
            this.overlays = [];

            if (!this.layerPrediction) return;

            for (const node of this.nodes) {
                const coord = ALL_COORDS[node.jiso_name];
                if (!coord) continue;
                const colorUp = this.getStatusColor(node.label_up || '미수신');
                const colorDn = this.getStatusColor(node.label_dn || '미수신');
                const worstLabel = this.getWorstLabel(node.label_up || '미수신', node.label_dn || '미수신');
                const isSelected = this.selectedNodeId === node.node_id;
                const ringColor = this.getRingColor(worstLabel);
                const ringDur = this.getRingDuration(worstLabel);
                const sameColor = colorUp === colorDn;

                // 마커에는 실측 속도 표시 (상행/하행 평균)
                const sUp = node.spd_up != null ? node.spd_up : null;
                const sDn = node.spd_dn != null ? node.spd_dn : null;
                let speedUp: number | null = null;
                if (sUp != null && sDn != null) speedUp = Math.round((sUp + sDn) / 2);
                else if (sUp != null) speedUp = Math.round(sUp);
                else if (sDn != null) speedUp = Math.round(sDn);

                const el = document.createElement('div');
                el.className = ['breathing-node', `status-${worstLabel}`, isSelected ? 'active' : ''].filter(Boolean).join(' ');
                el.style.cssText = `position:relative;display:flex;flex-direction:column;align-items:center;cursor:pointer;z-index:100;`;
                if (isSelected) el.style.transform = 'scale(1.18)';

                let circleHtml: string;
                if (sameColor) {
                    circleHtml = `<div class="breathing-circle" style="position:relative;width:42px;height:42px;border-radius:50%;display:flex;align-items:center;justify-content:center;box-shadow:0 2px 10px rgba(0,0,0,0.45);border:2px solid rgba(255,255,255,0.18);background:${colorUp};z-index:2;"></div>`;
                } else {
                    circleHtml = `<div class="breathing-circle" style="position:relative;width:42px;height:42px;border-radius:50%;display:flex;align-items:center;justify-content:center;box-shadow:0 2px 10px rgba(0,0,0,0.45);border:2px solid rgba(255,255,255,0.18);overflow:hidden;z-index:2;">
                        <div style="position:absolute;left:0;top:0;width:50%;height:100%;background:${colorUp};"></div>
                        <div style="position:absolute;right:0;top:0;width:50%;height:100%;background:${colorDn};"></div>
                    </div>`;
                }

                el.innerHTML = [
                    `<div class="breathing-ring" style="position:absolute;top:50%;left:50%;width:44px;height:44px;margin-top:-22px;margin-left:-22px;border-radius:50%;border:2px solid ${ringColor};pointer-events:none;animation:breathing-expand ${ringDur} ease-out infinite;"></div>`,
                    `<div class="breathing-ring breathing-ring-delay" style="position:absolute;top:50%;left:50%;width:44px;height:44px;margin-top:-22px;margin-left:-22px;border-radius:50%;border:2px solid ${ringColor};pointer-events:none;animation:breathing-expand ${ringDur} ease-out infinite;animation-delay:${parseFloat(ringDur) / 2}s;"></div>`,
                    circleHtml,
                    `<div class="breathing-label" style="margin-top:4px;font-size:10px;font-weight:600;color:#fff;text-shadow:0 1px 4px rgba(0,0,0,0.8);white-space:nowrap;text-align:center;">${node.jiso_name}</div>`,
                ].join('');
                el.addEventListener('click', (e) => {
                    e.stopPropagation();
                    this.selectedNodeId = node.node_id;
                    this.onNodeClick(node);
                });
                const pos = ol.proj.transform([coord[1], coord[0]], 'EPSG:4326', 'EPSG:3857');
                const overlay = new ol.Overlay({
                    element: el, positioning: 'center-center', stopEvent: true, offset: [0, 0],
                });
                olMap.addOverlay(overlay);
                overlay.setPosition(pos);
                this.overlays.push(overlay);
            }
        } catch (e) { }
    }

    private getWorstLabel(labelUp: string, labelDn: string): string {
        const rank: any = { '정체': 3, '혼잡': 2, '소통': 1, '미수신': 0 };
        return (rank[labelUp] || 0) >= (rank[labelDn] || 0) ? labelUp : labelDn;
    }

    speedToLabel(speed: number) {
        if (speed >= 25) return '소통';
        if (speed >= 15) return '혼잡';
        if (speed > 0) return '정체';
        return '미수신';
    }

    formatIncidentDate(ts: string): string {
        if (!ts) return '';
        try {
            const d = new Date(ts);
            if (isNaN(d.getTime())) return ts;
            const mm = (d.getMonth() + 1).toString().padStart(2, '0');
            const dd = d.getDate().toString().padStart(2, '0');
            const hh = d.getHours().toString().padStart(2, '0');
            const min = d.getMinutes().toString().padStart(2, '0');
            return `${mm}/${dd} ${hh}:${min}`;
        } catch (e) { return ts; }
    }

    getIncidentTypeColor(type: string): string {
        const colors: any = {
            '사고': '#d63031', '통제': '#e17055', '공사': '#f39c12',
            '행사': '#6c5ce7', '혼잡': '#e67e22', '낙하물': '#fd79a8',
            '고장': '#a29bfe', '재난': '#c0392b', '기타': '#636e72',
        };
        return colors[type] || '#f39c12';
    }

    // ─── CCTV Data & Markers ───
    async loadAllCctvData() {
        try {
            const res = await this.service.request.post('/api/data/cctv', {});
            if (res.code === 200 && res.data.data && Object.keys(res.data.data).length > 0) {
                this.cctvAllData = res.data.data;
            } else { this.cctvAllData = this.generateFallbackCctv(); }
        } catch (e) { this.cctvAllData = this.generateFallbackCctv(); }
        this.updateCctvMarkers();
    }

    private generateFallbackCctv(): any {
        const result: any = {};
        for (let i = 0; i < JISO_LIST.length; i++) {
            const name = JISO_LIST[i];
            const myCoord = ALL_COORDS[name];
            const conns = CONNECTIONS[name] || [];
            if (!myCoord || conns.length === 0) continue;
            const cameras: any[] = [];
            for (const connName of conns) {
                const connCoord = ALL_COORDS[connName];
                if (!connCoord) continue;
                let angleDeg = Math.atan2(connCoord[1] - myCoord[1], connCoord[0] - myCoord[0]) * 180 / Math.PI;
                if (angleDeg < 0) angleDeg += 360;
                const direction = this.angleToDirection(angleDeg);
                cameras.push({ cctvname: `${name} ${direction}방면`, hlsUrl: '', approach: `${direction}방면`, _angleDeg: angleDeg });
            }
            result[i] = { cameras };
        }
        return result;
    }

    private angleToDirection(angle: number): string {
        if (angle < 0) angle += 360;
        if (angle >= 337.5 || angle < 22.5) return '북';
        if (angle < 67.5) return '북동'; if (angle < 112.5) return '동';
        if (angle < 157.5) return '남동'; if (angle < 202.5) return '남';
        if (angle < 247.5) return '남서'; if (angle < 292.5) return '서';
        return '북서';
    }

    updateCctvMarkers() {
        const olMap = this.getOlMap();
        if (!olMap) return;
        for (const ov of this.cctvOverlays) { try { olMap.removeOverlay(ov); } catch (e) { } }
        this.cctvOverlays = [];
        if (!this.layerCctv) return;
        // 줌 레벨 15 이상에서 CCTV 아이콘 표시
        if (this.currentZoom < 15) return;

        for (const node of this.nodes) {
            const coord = ALL_COORDS[node.jiso_name];
            if (!coord) continue;
            const cctvInfo = this.cctvAllData[node.node_id];
            if (!cctvInfo?.cameras?.length) continue;
            const pos = ol.proj.transform([coord[1], coord[0]], 'EPSG:4326', 'EPSG:3857');
            cctvInfo.cameras.forEach((cam: any, idx: number) => {
                const angle = this.getCamAngle(cam, idx, cctvInfo.cameras.length);
                const rad = (90 - angle) * Math.PI / 180;
                const dist = 60;
                const hasStream = !!cam.hlsUrl;
                const bgColor = hasStream ? '#00b894' : '#636e72';
                const el = document.createElement('div');
                el.className = 'cctv-map-icon' + (hasStream ? ' has-stream' : ' no-stream');
                el.title = cam.cctvname || cam.approach || `CAM ${idx + 1}`;
                el.style.cssText = 'display:flex;flex-direction:column;align-items:center;cursor:pointer;z-index:90;';
                el.innerHTML = `<div class="cctv-icon-inner" style="width:28px;height:28px;border-radius:50%;display:flex;align-items:center;justify-content:center;font-size:12px;color:#fff;box-shadow:0 2px 6px rgba(0,0,0,0.3);border:2px solid rgba(255,255,255,0.2);background:${bgColor};"><i class="fas fa-video"></i></div><div class="cctv-icon-label" style="font-size:9px;color:#e8eaed;margin-top:2px;text-shadow:0 1px 3px rgba(0,0,0,0.7);white-space:nowrap;">${cam.approach || 'CAM' + (idx + 1)}</div>`;
                el.addEventListener('click', (e) => { e.stopPropagation(); this.openCctvPanel(node.node_id, node.jiso_name, idx); });
                const overlay = new ol.Overlay({
                    element: el, positioning: 'center-center', stopEvent: true,
                    offset: [Math.cos(rad) * dist, -Math.sin(rad) * dist],
                });
                olMap.addOverlay(overlay);
                overlay.setPosition(pos);
                this.cctvOverlays.push(overlay);
            });
        }
    }

    private getCamAngle(cam: any, idx: number, total: number): number {
        if (cam._angleDeg != null) return cam._angleDeg < 0 ? cam._angleDeg + 360 : cam._angleDeg;
        if (cam.approach) {
            const text = cam.approach.replace(/방면|방향|쪽|측/g, '').trim();
            const dirMap: any = { '동': 90, '서': 270, '남': 180, '북': 0, '북동': 45, '남동': 135, '남서': 225, '북서': 315 };
            for (const [key, val] of Object.entries(dirMap)) { if (text.includes(key)) return val as number; }
        }
        return (360 / Math.max(total, 1)) * idx;
    }

    // ─── CCTV Panel ───
    async openCctvPanel(nodeId: number, nodeName: string, camIdx: number = 0) {
        const cctvInfo = this.cctvAllData[nodeId];
        if (!cctvInfo?.cameras?.length) return;
        const cameras = cctvInfo.cameras.filter((c: any) => !!c.hlsUrl);
        if (cameras.length === 0) {
            this.debugMsg = `${nodeName}: 활성 CCTV 스트림 없음`;
            await this.service.render();
            return;
        }
        this.cctvPanelData = { nodeId, nodeName };
        this.cctvPanelCameras = cameras;
        this.cctvPanelSelectedIdx = camIdx < cameras.length ? camIdx : 0;
        this.cctvPanelVisible = true;
        await this.service.render();
        await this.playCctvByIdx(this.cctvPanelSelectedIdx);
    }

    async selectCctvTab(idx: number) {
        this.cctvPanelSelectedIdx = idx;
        await this.service.render();
        await this.playCctvByIdx(idx);
    }

    private async playCctvByIdx(idx: number) {
        const cam = this.cctvPanelCameras[idx];
        if (!cam?.hlsUrl) return;
        let streamUrl = cam.hlsUrl;
        if (streamUrl.startsWith('http:')) {
            streamUrl = `/api/proxy/cctv/stream?url=${encodeURIComponent(streamUrl)}`;
        }
        await this.playCctvStream(streamUrl);
    }

    async closeCctvPanel() {
        this.cctvPanelVisible = false;
        this.destroyHls();
        const video = document.getElementById('cctv-video') as HTMLVideoElement;
        if (video) { video.pause(); video.src = ''; }
        await this.service.render();
    }

    // ─── CCTV Panel Drag ───
    onCctvDragStart(event: MouseEvent) {
        event.preventDefault();
        this.cctvDragging = true;
        this.cctvDragStart = { mx: event.clientX, my: event.clientY, px: this.cctvPanelPos.x, py: this.cctvPanelPos.y };
        this.boundCctvDragMove = this.onCctvDragMove.bind(this);
        this.boundCctvDragEnd = this.onCctvDragEnd.bind(this);
        document.addEventListener('mousemove', this.boundCctvDragMove);
        document.addEventListener('mouseup', this.boundCctvDragEnd);
    }

    private onCctvDragMove(e: MouseEvent) {
        if (!this.cctvDragging) return;
        const dx = e.clientX - this.cctvDragStart.mx;
        const dy = e.clientY - this.cctvDragStart.my;
        this.cctvPanelPos.x = Math.max(0, this.cctvDragStart.px + dx);
        this.cctvPanelPos.y = Math.max(0, this.cctvDragStart.py + dy);
        this.service.render();
    }

    private onCctvDragEnd() {
        this.cctvDragging = false;
        document.removeEventListener('mousemove', this.boundCctvDragMove);
        document.removeEventListener('mouseup', this.boundCctvDragEnd);
    }

    // ─── CCTV Panel Resize ───
    onCctvResizeStart(event: MouseEvent) {
        event.preventDefault();
        event.stopPropagation();
        this.cctvResizing = true;
        this.cctvResizeStart = { mx: event.clientX, my: event.clientY, w: this.cctvPanelSize.w, h: this.cctvPanelSize.h };
        this.boundCctvResizeMove = this.onCctvResizeMove.bind(this);
        this.boundCctvResizeEnd = this.onCctvResizeEnd.bind(this);
        document.addEventListener('mousemove', this.boundCctvResizeMove);
        document.addEventListener('mouseup', this.boundCctvResizeEnd);
    }

    private onCctvResizeMove(e: MouseEvent) {
        if (!this.cctvResizing) return;
        const dx = e.clientX - this.cctvResizeStart.mx;
        const dy = e.clientY - this.cctvResizeStart.my;
        this.cctvPanelSize.w = Math.max(300, this.cctvResizeStart.w + dx);
        this.cctvPanelSize.h = Math.max(200, this.cctvResizeStart.h + dy);
        this.service.render();
    }

    private onCctvResizeEnd() {
        this.cctvResizing = false;
        document.removeEventListener('mousemove', this.boundCctvResizeMove);
        document.removeEventListener('mouseup', this.boundCctvResizeEnd);
    }

    private loadHlsJs(): Promise<void> {
        return new Promise((resolve) => {
            if ((window as any).Hls) { resolve(); return; }
            const script = document.createElement('script');
            script.src = 'https://cdn.jsdelivr.net/npm/hls.js@latest';
            script.onload = () => resolve(); script.onerror = () => resolve();
            document.head.appendChild(script);
        });
    }

    private async playCctvStream(url: string) {
        await this.loadHlsJs();
        const video = document.getElementById('cctv-video') as HTMLVideoElement;
        if (!video) return;
        this.destroyHls();
        const Hls = (window as any).Hls;
        if (Hls && Hls.isSupported()) {
            this.hlsInstance = new Hls({ enableWorker: true, lowLatencyMode: true });
            this.hlsInstance.loadSource(url);
            this.hlsInstance.attachMedia(video);
            this.hlsInstance.on(Hls.Events.MANIFEST_PARSED, () => { video.play().catch(() => {}); });
            this.hlsInstance.on(Hls.Events.ERROR, (_: any, data: any) => { if (data.fatal) console.warn('[HLS] Fatal error:', data.type); });
        } else if (video.canPlayType('application/vnd.apple.mpegurl')) {
            video.src = url; video.play().catch(() => {});
        }
    }

    // ─── Sidebar ───
    toggleSidebar() {
        this.sidebarOpen = !this.sidebarOpen;
        setTimeout(() => { const olMap = this.getOlMap(); if (olMap) olMap.updateSize(); }, 350);
        this.service.render();
    }

    // ─── Node Click & Popup ───
    async onNodeClick(node: any) {
        this.selectedNodeId = node.node_id;
        this.selectedNode = node;
        await this.loadHistory(node.node_id);
        await this.loadForecast(node.node_id);
        if (this.map) {
            const coord = ALL_COORDS[node.jiso_name];
            if (coord) {
                try {
                    const center = ol.proj.transform([coord[1], coord[0]], 'EPSG:4326', 'EPSG:3857');
                    const olMap = this.getOlMap();
                    if (olMap) { olMap.getView().setCenter(center); olMap.getView().setZoom(16); }
                } catch (e) { }
            }
        }
        this.updateMapMarkers();
        await this.showPopup(node);
        await this.service.render();
    }

    async showPopup(node: any) {
        this.popupData = {
            ...node,
            direction_up: node.direction_up || this.getDirectionLabel(node.node_id, 0),
            direction_dn: node.direction_dn || this.getDirectionLabel(node.node_id, 1),
            incidents: [],
            incidents_loaded: false,
        };
        if (this.layerCctv) {
            try {
                const res = await this.service.request.post('/api/data/cctv', { nodeId: node.node_id });
                if (res.code === 200 && res.data.data) {
                    this.popupData.cctv = res.data.data;
                }
            } catch (e) { }
        }
        if (this.layerIncident) {
            try {
                const res = await this.service.request.post('/api/data/incidents', { nodeId: node.node_id });
                if (res.code === 200) this.popupData.incidents = res.data.data || [];
            } catch (e) { }
            this.popupData.incidents_loaded = true;
        }
        // 5분마다 돌발 자동 갱신
        if (this.incidentInterval) clearInterval(this.incidentInterval);
        this.incidentInterval = setInterval(async () => {
            if (!this.popupVisible || !this.popupData) return;
            try {
                const r = await this.service.request.post('/api/data/incidents', { nodeId: this.popupData.node_id });
                if (r.code === 200) {
                    this.popupData.incidents = r.data.data || [];
                    this.popupData.incidents_loaded = true;
                    await this.service.render();
                }
            } catch (e) { }
        }, 5 * 60 * 1000);
        this.popupVisible = true;
        await this.service.render();
        await this.renderSpeedChart();
        await this.renderForecastChart();
    }

    async closePopup() {
        this.popupVisible = false;
        if (this.incidentInterval) { clearInterval(this.incidentInterval); this.incidentInterval = null; }
        await this.service.render();
    }

    // ─── History ───
    async loadHistory(nodeId: number) {
        try {
            const res = await this.service.request.post('/api/data/history', { nodeId, hours: 24 });
            if (res.code === 200) this.chartData = res.data.data || [];
        } catch (e) { }
        await this.service.render();
    }

    async loadForecast(nodeId: number) {
        try {
            const res = await this.service.request.post('/api/data/forecast', { nodeId });
            if (res.code === 200) this.forecastData = res.data.data || [];
        } catch (e) { this.forecastData = []; }
        await this.service.render();
    }

    // ─── Chart.js ───
    private loadChartJs(): Promise<void> {
        return new Promise((resolve) => {
            if ((window as any).Chart) { resolve(); return; }
            const script = document.createElement('script');
            script.src = 'https://cdn.jsdelivr.net/npm/chart.js@4';
            script.onload = () => resolve();
            script.onerror = () => resolve();
            document.head.appendChild(script);
        });
    }

    async renderSpeedChart() {
        await this.loadChartJs();
        const Chart = (window as any).Chart;
        if (this.chartInstance) { this.chartInstance.destroy(); this.chartInstance = null; }
        if (!Chart || !this.chartData?.length) return;
        await this.service.render();
        setTimeout(() => {
            const canvas = document.getElementById('speed-chart') as HTMLCanvasElement;
            if (!canvas) return;
            const labels = this.chartData.map((d: any) => {
                try {
                    const dt = new Date(d.ts || d.timestamp);
                    return `${dt.getHours().toString().padStart(2, '0')}:00`;
                } catch { return ''; }
            });
            const spdUp = this.chartData.map((d: any) => d.spd_up ?? null);
            const spdDn = this.chartData.map((d: any) => d.spd_dn ?? null);
            const datasets: any[] = [
                { label: '상행', data: spdUp, borderColor: '#4fc3f7', backgroundColor: 'rgba(79,195,247,0.1)', tension: 0.3, pointRadius: 2, borderWidth: 2, spanGaps: true },
                { label: '하행', data: spdDn, borderColor: '#e57373', backgroundColor: 'rgba(229,115,115,0.1)', tension: 0.3, pointRadius: 2, borderWidth: 2, spanGaps: true },
            ];
            this.chartInstance = new Chart(canvas, {
                type: 'line',
                data: { labels, datasets },
                options: {
                    responsive: true, maintainAspectRatio: false,
                    plugins: {
                        legend: { labels: { color: '#9aa0a6', font: { size: 10 } } },
                        tooltip: { mode: 'index', intersect: false },
                    },
                    scales: {
                        x: { ticks: { color: '#9aa0a6', font: { size: 9 }, maxRotation: 0, autoSkipPadding: 10 }, grid: { color: 'rgba(255,255,255,0.05)' } },
                        y: { min: 0, ticks: { color: '#9aa0a6', font: { size: 10 } }, grid: { color: 'rgba(255,255,255,0.05)' } },
                    },
                },
            });
        }, 100);
    }

    async renderForecastChart() {
        await this.loadChartJs();
        const Chart = (window as any).Chart;
        if (this.forecastChartInstance) {
            this.forecastChartInstance.destroy();
            this.forecastChartInstance = null;
        }
        if (!Chart || !this.forecastData?.length) return;
        await this.service.render();
        setTimeout(() => {
            const canvas = document.getElementById('forecast-chart') as HTMLCanvasElement;
            if (!canvas) return;
            const roundSpeed = (value: any) => {
                if (value == null) return null;
                const num = Number(value);
                return Number.isFinite(num) ? Math.round(num * 10) / 10 : null;
            };
            const labels = this.forecastData.map((d: any) => {
                try {
                    const dt = new Date(d.ts || d.timestamp);
                    const horizon = d.horizon != null ? `+${d.horizon}h` : '';
                    return horizon || `${dt.getHours().toString().padStart(2, '0')}:00`;
                } catch { return ''; }
            });
            const spdUp = this.forecastData.map((d: any) => roundSpeed(d.pred_spd_up));
            const spdDn = this.forecastData.map((d: any) => roundSpeed(d.pred_spd_dn));
            const datasets: any[] = [
                { label: '상행 예측', data: spdUp, borderColor: '#4fc3f7', backgroundColor: 'rgba(79,195,247,0.1)', tension: 0.3, pointRadius: 2, borderWidth: 2, spanGaps: true },
                { label: '하행 예측', data: spdDn, borderColor: '#e57373', backgroundColor: 'rgba(229,115,115,0.1)', tension: 0.3, pointRadius: 2, borderWidth: 2, spanGaps: true },
            ];
            this.forecastChartInstance = new Chart(canvas, {
                type: 'line',
                data: { labels, datasets },
                options: {
                    responsive: true, maintainAspectRatio: false,
                    plugins: {
                        legend: { labels: { color: '#9aa0a6', font: { size: 10 } } },
                        tooltip: {
                            mode: 'index',
                            intersect: false,
                            callbacks: {
                                label: (ctx: any) => `${ctx.dataset.label}: ${Number(ctx.parsed.y).toFixed(1)}km/h`,
                            },
                        },
                    },
                    scales: {
                        x: { ticks: { color: '#9aa0a6', font: { size: 9 }, maxRotation: 0, autoSkipPadding: 10 }, grid: { color: 'rgba(255,255,255,0.05)' } },
                        y: { min: 0, ticks: { color: '#9aa0a6', font: { size: 10 } }, grid: { color: 'rgba(255,255,255,0.05)' } },
                    },
                },
            });
        }, 100);
    }

    // ─── SSE ───
    connectSSE() {
        if (this.eventSource) this.eventSource.close();
        this.eventSource = new EventSource('/api/data/stream');
        this.eventSource.onmessage = async (event: MessageEvent) => {
            try {
                const data = JSON.parse(event.data);
                if (data.nodes) {
                    for (const d of data.nodes) {
                        const node = this.nodes[d.node_id];
                        if (node) {
                            if (d.spd_up != null) node.spd_up = d.spd_up;
                            if (d.spd_dn != null) node.spd_dn = d.spd_dn;
                            node.pred_spd_up = d.pred_spd_up;
                            node.pred_spd_dn = d.pred_spd_dn;
                            node.label_up = d.label_up; node.label_dn = d.label_dn;
                            node.color_up = d.color_up; node.color_dn = d.color_dn;
                        }
                    }
                    this.actualTs = data.actual_ts || data.now_ts || this.actualTs;
                    this.predTs = data.target_ts || this.predTs;
                    this.lastReceived = data.now_ts || this.lastReceived;
                    if (data.forecast && this.selectedNodeId >= 0) {
                        this.forecastData = data.forecast
                            .map((item: any) => {
                                const node = (item.nodes || []).find((n: any) => n.node_id === this.selectedNodeId);
                                return node ? {
                                    horizon: item.horizon,
                                    ts: item.target_ts,
                                    pred_spd_up: node.pred_spd_up,
                                    pred_spd_dn: node.pred_spd_dn,
                                } : null;
                            })
                            .filter((item: any) => item);
                        if (this.popupVisible) await this.renderForecastChart();
                    }
                    this.updateSummary();
                    this.updateMapMarkers();
                    await this.service.render();
                }
            } catch (e) { }
        };
        this.eventSource.onerror = () => { this.eventSource.close(); setTimeout(() => this.connectSSE(), 5000); };
    }

    // ─── Layers ───
    async toggleLayer(layer: string) {
        if (layer === 'prediction') this.layerPrediction = !this.layerPrediction;
        if (layer === 'cctv') { this.layerCctv = !this.layerCctv; this.updateCctvMarkers(); }
        if (layer === 'incident') this.layerIncident = !this.layerIncident;
        this.updateMapMarkers();
        await this.service.render();
    }

    logout() { sessionStorage.removeItem('traffic_token'); this.service.href('/access'); }
}

export default PageTrafficMainComponent;